import GhostBar from "./GhostBar";
import GhostCardContainer from "./GhostCardContainer";

const GhostOverallBudgetCard = () => {
  return (
    <GhostCardContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Left: Total Spent Metric */}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <GhostBar width="80px" height="32px" />
          <GhostBar width="160px" height="12px" />
        </div>

        {/* Right: Percentage/Visual Metric */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            gap: "8px",
          }}
        >
          <GhostBar width="60px" height="24px" />
        </div>
      </div>

      {/* Progress Bar Mirror */}
      <div>
        <GhostBar width="100%" height="12px" style={{ borderRadius: "10px" }} />
      </div>
    </GhostCardContainer>
  );
};

export default GhostOverallBudgetCard;
